import { Card } from "@/components/ui/card";

export default function KpiCard({ label, value, sub, icon: Icon, accent = "text-slate-600", testId }) {
  return (
    <Card
      data-testid={testId}
      className="border border-slate-200 bg-white shadow-none p-5 hover:border-slate-300 transition-colors"
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="label-caps">{label}</div>
          <div className="mt-2 data-value">{value}</div>
          {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
        </div>
        {Icon && (
          <div className={`p-2 rounded-md bg-slate-100 ${accent}`}>
            <Icon className="w-5 h-5" strokeWidth={1.75} />
          </div>
        )}
      </div>
    </Card>
  );
}
